module.exports = {
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL
};
